/**
 * @generated SignedSource<<d09aaa51571bcb313f4c4045d84c31e7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MATConsultationHistoryDescriptionList_matConsultationHistory$data = {
  readonly created: any;
  readonly nextContactDate: any | null;
  readonly " $fragmentType": "MATConsultationHistoryDescriptionList_matConsultationHistory";
};
export type MATConsultationHistoryDescriptionList_matConsultationHistory$key = {
  readonly " $data"?: MATConsultationHistoryDescriptionList_matConsultationHistory$data;
  readonly " $fragmentSpreads": FragmentRefs<"MATConsultationHistoryDescriptionList_matConsultationHistory">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MATConsultationHistoryDescriptionList_matConsultationHistory",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "created",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nextContactDate",
      "storageKey": null
    }
  ],
  "type": "MATConsultationHistory",
  "abstractKey": null
};

(node as any).hash = "e86e4eafee5d00c746222f0c6019647a";

export default node;
